import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort} from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import {TranslateService} from '@ngx-translate/core';
import {IdexService} from '../../../idex.service';

@Component({
   selector: 'app-log-assign-dialog',
   templateUrl: './log-assign-dialog.component.html',
   styleUrls: ['./log-assign-dialog.component.css']
})
export class LogAssignDialogComponent implements OnInit {
   displayedColumns = ['reassign_from', 'reassign_to', 'reassign_by', 'reassign_date'];
   resultsLength = 0;
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild('wfpaginator', { static: true }) wpaginator: MatPaginator;
   public dataSource: any;

   constructor(private dialogRef: MatDialogRef<LogAssignDialogComponent>, private translate: TranslateService,
               public services: IdexService, @Inject(MAT_DIALOG_DATA) public data: any) {
   }

   ngOnInit() {
      this.dataSource = new MatTableDataSource(this.data.taskReassign);
      this.dataSource.paginator = this.wpaginator;
   }


}
